import React, { useCallback, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { SignModal } from '@components/SignModals';
import { logout } from '@modules/Login';
import {
  acceptWaiverAcknowledgment,
  contentByPurposeSelector,
  getWaiverAcknowledgment,
  GlobalWeaverPurposes,
  idByPurposeSelector,
  requiredByPurposeSelector,
} from '@modules/globalWeaver';
import { currentEligibilitySelector } from '@modules/userProfileData';

import { locale } from './locale';

export const TermsOfUse = () => {
  const dispatch = useDispatch();
  const currentEligibility = useSelector(currentEligibilitySelector);
  const termsOfUseRequired = useSelector((state: RootState) =>
    requiredByPurposeSelector(state, { purpose: GlobalWeaverPurposes.TermsOfUse }),
  );
  const waiverId = useSelector((state: RootState) =>
    idByPurposeSelector(state, { purpose: GlobalWeaverPurposes.TermsOfUse }),
  );
  const { title, body } = useSelector((state: RootState) =>
    contentByPurposeSelector(state, { purpose: GlobalWeaverPurposes.TermsOfUse }),
  );

  const onClose = useCallback(() => {
    dispatch(logout({ inactivityLogout: false }));
  }, [dispatch]);

  const onSubmit = useCallback(() => {
    if (currentEligibility?.id && waiverId) {
      dispatch(acceptWaiverAcknowledgment({ purpose: GlobalWeaverPurposes.TermsOfUse, waiverId }));
    }
  }, [currentEligibility?.id, waiverId, dispatch]);

  useEffect(() => {
    if (currentEligibility) {
      dispatch(getWaiverAcknowledgment(GlobalWeaverPurposes.TermsOfUse));
    }
  }, [currentEligibility, dispatch]);

  return (
    <SignModal
      open={termsOfUseRequired}
      onClose={onClose}
      onSubmit={onSubmit}
      title={title}
      body={body}
      cancelButtonTitle={locale.cancel}
      signButtonTitle={locale.accept}
    />
  );
};
